import React, { useMemo } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import dayjs from 'dayjs';
import 'styles/date-picker.css';

export default function CustomDatePicker({
    startDate,
    endDate,
    onChange,
    dateFormat = 'MM/yy',
    placeholderText = 'Date Range',
    showPopperArrow = false,
    selectsRange = true,
    presets = [],
    ...rest
}) {
    const RangeInput = useMemo(() => React.forwardRef(({ onClick }, ref) => {
        const label = startDate && endDate
            ? `${dayjs(startDate).format('MM/YY')} to ${dayjs(endDate).format('MM/YY')}`
            : placeholderText;
        const hasRange = Boolean(startDate && endDate);
        return (
            <button
                type="button"
                onClick={onClick}
                ref={ref}
                className="flex w-40 items-center justify-between gap-3 rounded-full border border-gray-300 px-4 py-1 text-sm"
            >
                <span className="text-gray-900">{label}</span>
                {hasRange ? (
                    <button
                        type="button"
                        aria-label="Clear date range"
                        className="grid h-5 w-5 place-items-center rounded-full text-gray-800 hover:bg-gray-200"
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            onChange([null, null]);
                        }}
                    >
                        <svg
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            stroke="currentColor"
                            strokeWidth="2"
                            className="h-4 w-4"
                        >
                            <path d="M6 6l12 12M18 6L6 18" />
                        </svg>
                    </button>
                ) : (
                    <svg
                        className="h-5 w-5 text-gray-800"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <rect x="3" y="4" width="18" height="18" rx="4" />
                        <path d="M16 2v4M8 2v4M3 10h18" />
                    </svg>
                )}
            </button>
        );
    }), [startDate, endDate, onChange, placeholderText]);

    const hasPresets = Array.isArray(presets) && presets.length > 0;

    return (
        <div className="flex flex-col gap-2">
            {hasPresets ? (
                <div className="flex flex-wrap gap-2">
                    {presets.map((preset) => (
                        <button
                            type="button"
                            key={preset?.label}
                            className="rounded-full border border-gray-300 px-3 py-1 text-xs font-medium text-gray-800 transition hover:border-gray-400 hover:bg-gray-100"
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                if (Array.isArray(preset?.range)) {
                                    onChange(preset.range);
                                }
                            }}
                        >
                            {preset?.label}
                        </button>
                    ))}
                </div>
            ) : null}

            <DatePicker
                selectsRange={selectsRange}
                startDate={startDate}
                endDate={endDate}
                onChange={onChange}
                dateFormat={dateFormat}
                placeholderText={placeholderText}
                customInput={<RangeInput />}
                showPopperArrow={showPopperArrow}

                // showMonthDropdown
                // showYearDropdown
                // dropdownMode="select"
                // dropdownStyle={{
                //     width: '100%',
                //     height: '40px',
                // }}
                {...rest}
            />
        </div>
    );
}


